import { UserMemberSubscriptionBean } from "@gymflow/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { apiV2 } from "libs/api/src/lib/apiV2";
import { useTranslation } from "react-i18next";

import { ConfirmModal } from "./ConfirmModal";

export type DeleteMemberModalProps = {
  onConfirm: () => void;
  onClose: () => void;
  as: "staff" | "member";
  memberId: string;
};
export function DeleteMemberModal({
  onClose,
  onConfirm,
  as,
  memberId,
}: DeleteMemberModalProps) {
  const { t } = useTranslation();

  const deleteMutation = useMutation(
    apiV2[as].member.mutations.deleteAccount(),
  );
  const { data: member } = useQuery(
    apiV2[as].member.queries.idDeprecated(memberId),
  );

  const hasActiveMembership = !!member?.subscriptions?.find(
    (e: UserMemberSubscriptionBean) => e.active,
  );
  return !hasActiveMembership ? (
    <ConfirmModal
      onConfirm={async () => {
        try {
          await deleteMutation.mutateAsync({ userId: memberId });
          onConfirm();
        } catch {
          onClose();
        }
      }}
      onCancel={onClose}
      title={t("pages.deleteAccountModal.title")}
      type="danger"
    >
      {t("pages.deleteAccountModal.description")}
    </ConfirmModal>
  ) : (
    <ConfirmModal
      onCancel={onClose}
      title={t("pages.cantDeleteAccountModal.title")}
      type="warning"
    >
      {t("pages.cantDeleteAccountModal.description")}
    </ConfirmModal>
  );
}
